import React, { useState, useEffect } from 'react'
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb'
import EvnVar from '../../../EnvVar';
import Cookies from 'js-cookie';
import axios from 'axios';

function DashboardDash() {
    const baseURL = EvnVar()
    const [dashboard, setDashboard] = useState([])
    const [yourScore, setYourScore] = useState({})
    const [leaderBoard, setLeaderboard] = useState([])
    useEffect(() => {
        // Fetching stats data
        function fetchingStats() {
            const token = Cookies.get("jwt");
            let config = {
                method: "get",
                maxBodyLength: Infinity,
                url: `${baseURL}/dash/stats`,
                headers: {
                    Authorization: token,
                },
                withCredentials: true,
            };

            axios
                .request(config)
                .then((response) => {
                    let result = JSON.stringify(response.data);
                    let data = JSON.parse(result);
                    setDashboard(data);
                    console.log("Stats Data", data);
                })
                .catch((error) => {
                    console.log("Error fetching on Stats data:", error);
                });
        }

        fetchingStats()

        // Fetching Leaderboard data
        function fetchingLeaderBoard() {
            const token = Cookies.get("jwt");
            let config = {
                method: "get",
                maxBodyLength: Infinity,
                url: `${baseURL}/dash/leaderbord`,
                headers: {
                    Authorization: token,
                },
                withCredentials: true,
            };

            axios
                .request(config)
                .then((response) => {
                    let result = JSON.stringify(response.data);
                    let data = JSON.parse(result);
                    // console.log("Leader Board Data", data);
                    setYourScore(data.ambs_point.myscore);
                    setLeaderboard(data.ambs_point.ambs_points);
                })
                .catch((error) => {
                    console.log("Error fetching on Leader Board data:", error);
                });
        }

        fetchingLeaderBoard()
    }, []);
    return (
        <>
            <Breadcrumb data="Dashboard" />
            <div className='content-body'>
                <div className="card-section row">
                    <div className='col-md-4'>
                        <div className='card card-hero'>
                            <div className='card-header'>
                                <div className="card-icon">
                                    <i className="fas fa-user-shield"></i>
                                </div>
                                <h5>{dashboard.totalEvent}</h5>
                                <div className="card-description">Events</div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='card card-hero'>
                            <div className='card-header'>
                                <div className="card-icon">
                                    <i className="fas fa-user-shield"></i>
                                </div>
                                <h5>{dashboard.totalMedia}</h5>
                                <div className="card-description">Media</div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='card card-hero'>
                            <div className='card-header'>
                                <div className="card-icon">
                                    <i className="fas fa-user-shield"></i>
                                </div>
                                <h5>{dashboard.totalSlogan}</h5>
                                <div className="card-description">Slogan</div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='card card-hero'>
                            <div className='card-header'>
                                <div className="card-icon">
                                    <i className="fas fa-user-shield"></i>
                                </div>
                                <h5>{dashboard.totalSocialMedia}</h5>
                                <div className="card-description">Total Social Media</div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='card card-hero'>
                            <div className='card-header'>
                                <div className="card-icon">
                                    <i className="fas fa-user-shield"></i>
                                </div>
                                <h5>{dashboard.totalStory}</h5>
                                <div className="card-description">Total Story</div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='card card-hero'>
                            <div className='card-header'>
                                <div className="card-icon">
                                    <i className="fas fa-user-shield"></i>
                                </div>
                                <h5>{dashboard.totalSurvey}</h5>
                                <div className="card-description">Total Participants</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='table-data'>
                    <div className='d-flex align-items-center justify-content-between'>
                        <h4>Leaderboard</h4>
                        <div className='total-points'>Your Score: <span>{yourScore? yourScore?.totalpoint: 0} </span></div>
                    </div>
                    <div className='table-responsive'>
                        <table className='table table-bordered'>
                            <thead>
                                <tr>
                                    <th>Ambassador Name</th>
                                    <th>Branch</th>
                                    <th>Points</th>
                                </tr>
                            </thead>
                            <tbody>
                                {leaderBoard && leaderBoard.map((value, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{value.ambassador.fullname}</td>
                                            <td>{value.ambassador.User.name}</td>
                                            <td>{value.totalpoint}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DashboardDash
